import { Component } from "@angular/core";
import { EdpPaymentAgreementService } from "@edp-services/edp-payment-agreement.service";

@Component({
    selector: "edp-payment-agreement",
    templateUrl: "./edp-payment-agreement.component.html",
    styleUrls: ["./edp-payment-agreement.component.scss"],
})
export class EdpPaymentAgreementComponent {
    public selectedComponent = this.edpPaymentAgreementService.getSelectedComponent();

    constructor(private edpPaymentAgreementService: EdpPaymentAgreementService) { }
}
